import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { status: String, targetOrigin: String };

  connect() {
    window.parent.postMessage(
      { type: 'universign:complete', status: this.statusValue },
      this.targetOriginValue
    );
  }
}
